import React, { useState, useEffect, useMemo } from "react";
import { Formik, Form, FormikHelpers } from "formik";
import * as Yup from "yup";

//MUI
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import FormikControl from "../../components/formik/FormikControl";
import Loader from "../../components/loader/Loader";

import { Mode } from "./CsgoPage";
import { createAutocompleteOptions } from "../../utility/utils";
import { fetchCSGOs } from "../../redux/actions/CSGOActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { CSGOModel } from "../../models/CSGOModel";
import CSGOService from "../../services/CSGOService";

const validationSchema = Yup.object({
  name: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
  csgouserId: Yup.number().min(1, "Required").required("Requierd"),
  // status: Yup.string().required("Required"),
});

type FormProps = Yup.InferType<typeof validationSchema>;

type Props = {
  mode: Mode;
  handleModalClose: () => void;
  data?: CSGOModel;
};

const CsgoForm = ({ mode, handleModalClose, data }: Props) => {
  const initialValues = useMemo(
    () => ({
      name: "",
      description: "",
      csgouserId: 0,
      // status: "",
    }),
    []
  );

  const [formState, setFormState] = useState<FormProps>(initialValues);
  const dispatch = useAppDispatch();
  const allUsers = useAppSelector((state) => state.user.all_Users);
  const displayToast = useAppSelector((state) => state.toast.displayToast);

  const userOptions = useMemo(() => {
    return createAutocompleteOptions(
      allUsers,
      "userId",
      "firstName",
      "lastName"
    );
  }, [allUsers]);

  useEffect(() => {
    if (mode === "edit" && data) {
      setFormState(() => ({
        name: data.name,
        description: data.description,
        csgouserId: data.csgouserId,
        // status: data.isActive ? "active" : "inactive",
      }));
    }
  }, [mode, data]);

  const submitHandler = async (
    values: FormProps,
    actions: FormikHelpers<FormProps>
  ) => {
    try {
      let formData: CSGOModel = {
        csgoid: 0,
        name: "",
        description: "",
        csgouserId: 0,
        isActive: true,
        createdDate: new Date(),
        modifiedDate: new Date(),
      };
      if (mode === "add") {
        formData.name = values.name;
        formData.description = values.description;
        formData.csgouserId = values.csgouserId;
        // formData.isActive = values.status === "active" ? true : false;
      } else if (data) {
        formData = {
          ...data,
          name: values.name,
          description: values.description,
          csgouserId: values.csgouserId,
          // isActive: values.status === "active" ? true : false,
          modifiedDate: new Date(),
        };
      }
      await CSGOService.createCSGO(formData, data?.csgoid);
      actions.setSubmitting(false);
      handleModalClose();
      dispatch(fetchCSGOs());
      displayToast(
        `CSGO ${mode === "add" ? "created" : "updated"} successfully`,
        "success"
      );
    } catch (error) {
      actions.setSubmitting(false);
    }
  };
  return (
    <Formik
      initialValues={formState}
      validationSchema={validationSchema}
      onSubmit={submitHandler}
      enableReinitialize={true}
    >
      {(formik) => (
        <>
          <Form>
            <Stack gap={2}>
              <FormikControl
                control="input"
                type="text"
                name="name"
                size="small"
                label="Name"
                placeholder="Enter Name"
              />
              <FormikControl
                control="input"
                multiline
                maxRows={2}
                name="description"
                size="small"
                label="Description"
                placeholder="Enter Description"
              />
              <FormikControl
                control="autocomplete"
                options={userOptions}
                name="csgouserId"
                size="small"
                label="CSGO User"
                placeholder="Select CSGO User"
              />
              {/* <FormikControl
                control="autocomplete"
                options={statusOptions}
                name="status"
                size="small"
                label="Status"
                placeholder="Select Status"
              /> */}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={formik.isSubmitting}
              >
                Submit
              </Button>
            </Stack>
          </Form>
          {formik.isSubmitting && <Loader />}
        </>
      )}
    </Formik>
  );
};

export default CsgoForm;
